import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getProfile, updateProfile } from '../../../actions/homeAction';
import LoadingOverlay from 'react-loading-overlay';
import Loading from '../common/Loading';

class BusinessProfile extends Component {
	state = {};
	componentDidMount() {
		this.props.getProfile();
	}
	componentWillReceiveProps(nextProps) {
		this.setState({
			profile: nextProps.home.profile,
			loading: nextProps.home.loading,
		});

		if (nextProps.home.profile) {
			this.setState({
				email: nextProps.home.profile.email,
				firstName: nextProps.home.profile.firstName,
				lastName: nextProps.home.profile.lastName,
				phone: nextProps.home.profile.phone,
			});
		}
	}

	onInputChange = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};

	onUpdateProfle = () => {
		var data = {
			email: this.state.email,
			firstName: this.state.firstName,
			lastName: this.state.lastName,
			phone: this.state.phone,
		};
		this.props.updateProfile(data);
	};
	render() {
		return (
			<div>
				<LoadingOverlay active={this.state.loading} text={<Loading></Loading>}></LoadingOverlay>
				<h5 className="bg-primary text-white p-2">
					<Link to="/">
						<i className="fa fa-home"></i> Home{' '}
					</Link>{' '}
					<i className="fa fa-chevron-right mx-3"></i> My Profile
				</h5>
				<div className="py-5">
					<div className="container">
						<div class="row d-flex justify-content-between">
							<div class="col-md-3 dashboard-left mb-5">
								<div class="checkout-sub">
									<div className="list-group shadow-sm">
										<Link to="/account" className="list-group-item product-link ">
											Your Profile
										</Link>
										<Link
											to="/business-profile"
											className="list-group-item product-link text-white bg-primary"
										>
											Your Business Profile
										</Link>
										<Link to="/account-settings" className="list-group-item product-link">
											Account Settings
										</Link>

										<Link to="/order" className="list-group-item product-link">
											Orders
										</Link>
										<Link to="/languages" className="list-group-item product-link">
											Languages
										</Link>
										<Link to="/address" className="list-group-item product-link">
											Address Book
										</Link>

										<Link to="/favourite" className="list-group-item product-link">
											Favourites
										</Link>

										<Link
											className="list-group-item product-link cursor-pointer"
											onClick={() => {
												localStorage.clear();
												window.location.href = '#/';
												window.location.reload();
											}}
										>
											Logout
										</Link>
									</div>
								</div>
							</div>
							<div class="col-md-8 checkout-right">
								<div class="checkout-sub">
									<div class="myprofile-main">
										<div class="profiledata">
											<div className="row  d-flex align-items-center justify-content-center ">
												<div className="col-md-2 mx-auto d-flex align-items-center justify-content-center flex-column">
													<img
														className="rounded-circle"
														style={{ width: '100%' }}
														src="data:image/jpeg;base64,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"
														alt=""
													/>
													<div className="btn btn-primary mt-3">CHANGE</div>
												</div>

												<div className="col-md-7 mx-auto">
													<div class="d-flex justify-content-between">
														<label>Business Name </label>
														<p>
															Test
															{this.state.profile !== undefined
																? this.state.profile.firstName
																: ''}
														</p>
													</div>
													<div class="d-flex justify-content-between">
														<label>Business Email Address</label>
														<p>
															test@business.com
															{this.state.profile !== undefined
																? this.state.profile.email
																: ''}
														</p>
													</div>
													<div class="d-flex justify-content-between">
														<label>Business Type</label>
														<p>
															test
															{this.state.profile !== undefined
																? this.state.profile.phone
																: ''}
														</p>
													</div>
													<div class="d-flex justify-content-between">
														<label>Verified </label>
														<p>
															<div className="btn btn-success text-white">
																<i className="fa fa-check"></i> VERIFIED{' '}
															</div>
															{this.state.profile !== undefined
																? this.state.profile.lastName
																: ''}
														</p>
													</div>
												</div>
											</div>
										</div>
										<hr />
										<div class="profileform">
											<div class="form-group">
												<input
													type="text"
													id=""
													name="firstName"
													placeholder="Business Name"
													class="form-control"
													value={this.state.firstName}
													onChange={this.onInputChange}
												/>
											</div>

											<div class="form-group">
												<input
													type="text"
													id=""
													name="email"
													placeholder="Business Email Address"
													class="form-control"
													value={this.state.email}
													onChange={this.onInputChange}
												/>
											</div>
											<div class="form-group">
												<select name="" id="" className="form-control">
													<option value="">Select Business Type</option>
												</select>
											</div>
											<div class="change-div">
												<div class="btn btn-primary" onClick={this.onUpdateProfle}>
													UPDATE
												</div>{' '}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

BusinessProfile.propsTypes = {
	getProfile: PropTypes.func.isRequired,
	home: PropTypes.object.isRequired,
};

var mapStateToProps = (state) => ({
	home: state.home,
	banners: state.home.bannersList,
});

export default connect(mapStateToProps, { getProfile, updateProfile })(BusinessProfile);
